import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';

import { HyperSpaceBarChartWidgetOptions } from './types';
import { observable } from 'mobx';
import { BaseXYAxisChartOptions, MetaInfoOptions } from '@sprinklr/stories/hyperspaceWidgets/types';

export class HyperSpaceBarChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceBarChartWidgetOptions {
    @observable labels = { enabled: false, inset: false };
    @observable barHeight = 90;
    @observable includeMetrics = false;
    @observable zeroFill = true;
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        grid: {
            enabled: false,
        },
        xAxis: {
            ticks: {
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };
}
